import React, { useState } from "react";
import styles from "./feed.module.scss";

import FeedHeader from "./feedCard/feedHeader";
import FeedActions from "./feedCard/feedActions";
import FeedComments from "./feedCard/feedComments";
import FeedAddComment from "./feedCard/feedAddComment";

import FeedPost from "./feedTypes/post";
import PollPost from "./feedTypes/poll";
import TicketPost from "./feedTypes/ticket";
import { FeedAPI } from "./feed.service";

export default function FeedCard({
  post,
  user,
  getFeeds,
  onEditPost,
  isHideActions
}) {
  const [showComments, setShowComments] = useState(false);

  const [comments, setComments] = useState([]);

  const getComments = async(post) => {
    try {
      if (post.feedType === "ticket") {
        const comments = await FeedAPI.getCommentsTicket(
          post.taskId,
          post.workspace
        );
        setComments(comments?.comments);
      } else {
        const comments = await FeedAPI.getCommentsTicket(
          post.taskId,
          post.workspace
        );
        setComments(comments?.comments);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const renderContent = () => {
    switch (post.feedType) {
    case "poll":
      return <PollPost post={post} />;

    case "ticket":
      return <TicketPost post={post} />;

    case "feed":
    default:
      return <FeedPost post={post} />;
    }
  };

  return (
    <article className={styles.card}>
      <FeedHeader
        isHideActions={isHideActions}
        post={post}
        user={user}
        getFeeds={getFeeds}
        onEditPost={onEditPost}
      />

      <div className={styles.content}>{renderContent()}</div>

      <FeedActions
        post={post}
        getFeeds={getFeeds}
        onCommentClick={() => {
          setShowComments(!showComments);
          getComments(post);
        }}
      />

      {showComments && (
        <div className={styles.commentsWrap}>
          <FeedComments actions={false} comments={comments || []} post={post} />
          <FeedAddComment
            onAdd={async(text) => {
              try {
                if (post.feedType === "ticket") {
                  await FeedAPI.createCommentTicket(
                    {
                      content: text,
                      ticketId: post?.taskId
                    },
                    null,
                    post?.workspace
                  );
                }

                if (post.feedType === "poll") {
                  await FeedAPI.createComment({
                    pollId: post?.id,
                    content: text
                  });
                }

                if (post.feedType === "feed") {
                  await FeedAPI.createComment({
                    postId: post?.id,
                    content: text
                  });
                }

                await getFeeds(); // refresh full feed list
              } catch (err) {
                console.error(err);
              }
            }}
          />
        </div>
      )}
    </article>
  );
}
